























































































































import Vue, { VueConstructor } from 'vue';
import { CaseVm } from '../../viewModel';

export default (Vue as VueConstructor<Vue & {
  $refs: {},
}>).extend({
  name: 'OpenCasesTable',
  components: {
  },
  props: {
    caseData: {
      type: Array as () => CaseVm[],
      required: false,
      default: () => [] as CaseVm[],
    },
    gcs: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expand: false as boolean,
      isMobile: false as boolean,
      title: 'Open Cases' as string,
      headers: [
        { text: 'Beschreibung', value: 'caseDescriptionShort', class: 'black--text' },
        { text: 'Eröffnet am', value: 'createDate', class: 'black--text' },
        { text: 'Produkt', value: 'caseGroup1', class: 'black--text' },
        { text: 'Status', value: 'caStDescription', class: 'black--text' },
        { text: 'Zuständig', value: 'staffSignature', class: 'black--text' },

      ],
      subHeaders: [
        { text: 'Mitarbeitername', value: 'staffSignature', class: 'black--text' },
        { text: 'Beschreibung', value: 'caTcDescription', class: 'black--text' },
        { text: 'Datum (Startzeit)', value: 'caTcStart', class: 'black--text' },
        { text: 'Uhrzeit (Startzeit)', value: 'hour', class: 'black--text' },
      ],
    };
  },
  created() {
    this.getAllOpenCases();
    if (this.gcs) {
      this.headers.unshift({ text: 'Vorgang-ID', value: 'recordId', class: 'black--text' });
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    getAllOpenCases() {
      this.$emit('getAllOpenCases');
    },
    expandAttendanceOpenCase(props: any) {
      props.expanded = !props.expanded;
      this.$emit('expandAttendanceOpenCase', props);
    },
  },
});
